import fetch from 'isomorphic-fetch';
import moment from 'moment';

import callApi from '../../util/apiCaller';
import { unique } from '../../util/array';
import { toArrayBuffer } from '../../util/data';
import config from '../../config';

import { getSession, isSessionActive, isSessionUpcoming, getSessionOption, getSessionEnd, getFinalMark, SESSION_STATUS_ARCHIVED, SESSION_STATUS_CORRECTED, SESSION_STATUS_ONCORRECTION, canCorrectSession } from '../Session/SessionActions';
import { sendSocket, setIsFetching, setRedirect, getItemsRequest } from '../App/AppActions';
import { capitalizeFirstLetter } from '../../util/text';
import { getApplicantQuestionAnswer } from '../Answer/AnswerActions';
import { getModelEvent, getModelEvents } from '../Model/ModelHelpers';

// Export Constants
export const SET_APPLICANTS = 'SET_APPLICANTS';
export const SET_SESSION_APPLICANTS = 'SET_SESSION_APPLICANTS';
export const SET_GROUP_APPLICANTS = 'SET_GROUP_APPLICANTS';
export const UPDATE_APPLICANT_KEY = 'UPDATE_APPLICANT_KEY';
export const UPDATE_GROUP_APPLICANT_ANSWER = 'UPDATE_GROUP_APPLICANT_ANSWER';
export const SET_CURRENT_APPLICANT = 'SET_CURRENT_APPLICANT';
export const SET_APPLICANT_ATTENTION = 'SET_APPLICANT_ATTENTION';
export const SET_LAST_PROCTORING_ACTIVITY = 'SET_LAST_PROCTORING_ACTIVITY';
export const SET_APPLICANT_PROCTORING_HANDLES = 'SET_APPLICANT_PROCTORING_HANDLES';
export const SET_APPLICANT_PROCTOR_AUDIO_ACTIVE = 'SET_APPLICANT_PROCTOR_AUDIO_ACTIVE';

export const APPLICANT_STATUS_PENDING = 'pending';
export const APPLICANT_STATUS_ONPROGRESS = 'onprogress';
export const APPLICANT_STATUS_DONE = 'done';
export const APPLICANT_STATUS_ONPROCESS = 'onprocess';
export const APPLICANT_STATUS_ONCORRECTION = 'oncorrection';
export const APPLICANT_STATUS_CORRECTED = 'corrected';
export const APPLICANT_STATUS_BLOCKED = 'blocked';

export function getApplicantsRequest(pager = null) {
	// return dispatch => {
	//     dispatch(setIsFetching('applicants'));
	//     return callApi('applicants').then(result => {
	//         dispatch(setApplicants(result.applicants));
	//         return result.applicants;
	//     }).catch(err => {
	//         return null;
	//     });
	// };
	return dispatch => dispatch(getItemsRequest('applicants', null, items => dispatch(setApplicants(items || [], !pager)), { pager }, { isRecursive: pager === null }));
}

export function getSessionApplicantsRequest(sessionId, targettedApplicantsIds = [], disableCache = false, fieldsToSelect = null) {
	const extra = {};
	if(targettedApplicantsIds?.length) {
		extra.applicants = (targettedApplicantsIds || []).join(',');
	}
	if(disableCache) {
		extra.refreshCache = 1;
	}
	if(fieldsToSelect?.length) {
		extra.fields = fieldsToSelect.join(',');
	}
	return dispatch => dispatch(getItemsRequest(`session/${sessionId}/applicants`, 'applicants', items => dispatch(setSessionApplicants(sessionId, items)), { extra }, { isRecursive: true }));
	// return dispatch => {
	//     return callApi(`session/${sessionId}/applicants`).then(result => {
	//         result.applicants && dispatch(setSessionApplicants(sessionId, result.applicants));
	//         return result.applicants;
	//     }).catch(err => {
	//         return null;
	//     });
	// };
}
export function getApplicantRequest(id, isFromSession = false, userId = null) {
	return dispatch => {
		return callApi(`applicant/${id}?${isFromSession ? 'fromSession=1&' : ''}${userId ? `user=${userId}&` : ''}`).then(result => {
			result?.applicant && dispatch(setApplicants([result.applicant], false));
			return result?.applicant;
		}).catch(err => {
			return null;
		});
	};
}

export function getUserApplicantsRequest(userId) {
	return dispatch => dispatch(getItemsRequest(`user/${userId}/applicants`, 'applicants', null, null, { isRecursive: true }));
	// return dispatch => {
	//     return callApi(`user/${userId}/applicants`).then(result => {
	//         return result;
	//     }).catch(err => {
	//         return null;
	//     });
	// };
}

export function getGroupApplicantsRequest(applicantId) {
	return dispatch => {
		return callApi(`applicants/${applicantId}/group`).then(result => {
			result.applicants && dispatch(setGroupApplicants(result.applicants));
			return result.applicants;
		}).catch(err => {
			return null;
		});
	};
}

export function editApplicantRequest(applicant, requestAll = true) {
	return dispatch => {
		return callApi('applicant/edit', 'post', { applicant }).then(result => {
			result.applicant && requestAll && dispatch(getSessionApplicantsRequest(getApplicantSessionId(result.applicant), null, true));
			return result.applicant;
		}).catch(err => {
			return null;
		});
	};
}

export function getApplicantsToProctorRequest(sessionId) {
	return dispatch => {
		return callApi(`applicants/proctored/${sessionId}`).then(res => {
			if(res.needSetApplicantsToProctor) {
				return dispatch(setApplicantsToProctorRequest(sessionId));
			}
			if(res.applicants) {
				// dispatch(getSessionApplicantsRequest(sessionId));
				dispatch(setSessionApplicants(sessionId, res.applicants));
			}
			return res && res.applicants;
		}).catch(error => {
			return null;
		});
	};
}

export function setApplicantsToProctorRequest(sessionId) {
	return dispatch => {
		return callApi('applicants/proctor', 'post', { session: { _id: sessionId } }).then(res => {
			if(res.applicants && res.proctor) {
				dispatch(getSessionApplicantsRequest(sessionId, null, true));
				res.applicants.forEach(applicant => {
					dispatch(sendSocket({ type: 'applicant/edit', data: { applicant: applicant._id, session: sessionId, sendToApplicant: true } }));
				});
			}
			return res.applicants;
		}).catch(error => {
			if(error.message === 'ApplicantsToProctorAlreadySet') {
				// displayErrors('warning', 'Applicants to proctor are already set!');
			}
			return null;
		});
	};
}

export function correctApplicantRequest(applicant, newMarks, comment, isMassAction = false) {
	return dispatch => {
		return callApi('applicant/correct', 'post', { applicant: { _id: applicant._id }, newMarks, comment }).then(result => {
			!isMassAction && result.applicant && dispatch(getSessionApplicantsRequest(getApplicantSessionId(result.applicant), null, true));
			return result.applicant;
		}).catch(err => {
			return null;
		});
	};
}

export function resetApplicantCorrectionRequest(applicant, correctorId) {
	return dispatch => {
		return callApi('applicant/correct/reset', 'post', { applicant: { _id: applicant._id }, corrector: correctorId }).then(result => {
			result.applicant && dispatch(getSessionApplicantsRequest(getApplicantSessionId(result.applicant), null, true));
			return result.applicant;
		}).catch(err => {
			return null;
		});
	};
}

export function addApplicantTrackRequest(session, applicant, track) {
	return dispatch => callApi('applicant/addtrack', 'post', { session: { _id: session._id }, applicant: { _id: applicant._id }, track }).then(res => {
		return res.applicant;
	}).catch(error => {
		return null;
	});
}

export function setApplicantAccessRequest(sessionId, applicantId) {
	return dispatch => {
		return callApi(`session/${sessionId}/access?requestDate=${moment.utc().format()}`, 'get').then(res => {
			if(res && res.ok) {
				// dispatch(getApplicantsRequest());
				// dispatch(sendSocket({ type: 'applicant/edit', data: { applicant: applicantId, sendToApplicant: false } }));
				res.dates && dispatch(updateApplicantKey(applicantId, 'dates', res.dates, sessionId)); // TODO: Remove code on next major version
				res.events && dispatch(updateApplicantKey(applicantId, 'events', res.events, sessionId));
				dispatch(sendSocket({ type: 'applicant/update', data: { applicant: applicantId, session: sessionId, updates: [{ key: 'dates', value: res.dates }, { key: 'events', value: res.events }], sendToApplicant: true } }));
				res.changes && Object.keys(res.changes).forEach(key => dispatch(sendSocket({ type: 'applicant/update', data: { applicant: applicantId, session: sessionId, updates: [{ key, value: res.changes[key] }], sendToApplicant: true } })));
			}
			return res;
		}).catch(err => {
			return null;
		});
	};
}

export function setApplicantPageAccessRequest(sessionId, applicantId, pageId) {
	return dispatch => {
		return callApi(`session/${sessionId}/access/page/${pageId}`, 'get').then(res => {
			if(res && res.ok) {
				// dispatch(getApplicantsRequest());
				// dispatch(sendSocket({ type: 'applicant/edit', data: { applicant: applicantId, sendToApplicant: false } }));
				res.dates && dispatch(updateApplicantKey(applicantId, 'dates', res.dates, sessionId)); // TODO: Remove code on next major version
				res.events && dispatch(updateApplicantKey(applicantId, 'events', res.events, sessionId));
				dispatch(sendSocket({ type: 'applicant/update', data: { applicant: applicantId, session: sessionId, updates: [{ key: 'dates', value: res.dates }, { key: 'events', value: res.events }], sendToApplicant: true } }));
			}
			return res;
		}).catch(err => {
			return null;
		});
	};
}

export function setApplicantFinishRequest(sessionId, applicantId) {
	return dispatch => {
		return callApi(`session/${sessionId}/finish`).then(res => {
			if(res.ok) {
				// dispatch(getApplicantsRequest());
				// dispatch(sendSocket({ type: 'applicant/edit', data: { applicant: applicantId, sendToApplicant: true } }));
				res.dates && dispatch(updateApplicantKey(applicantId, 'dates', res.dates, sessionId)); // TODO: Remove code on next major version
				res.events && dispatch(updateApplicantKey(applicantId, 'events', res.events, sessionId));
				res.status && dispatch(updateApplicantKey(applicantId, 'status', res.status, sessionId));
				dispatch(sendSocket({ type: 'applicant/update', data: { applicant: applicantId, session: sessionId, updates: [{ key: 'dates', value: res.dates }, { key: 'events', value: res.events }, { key: 'status', value: res.status }], sendToApplicant: true } }));
			}
			return res.ok;
		}).catch(err => {
			return null;
		});
	};
}

// Set applicants.dates: instructionStarted, instructionAllowed, instructionFinished, accessAllowed, liveStarted, liveStopped
export function setApplicantDateRequest(sessionId, applicantId, type, userId = null, date = null, reset = false) {
	return dispatch => callApi(`session/${sessionId}/setdate`, 'post', { type, user: userId, date, reset }).then(res => {
		if(res.ok) {
			// dispatch(getSessionApplicantsRequest(sessionId));
			// dispatch(sendSocket({ type: 'applicant/edit', data: { applicant: applicantId, sendToApplicant: true } }));
			res.dates && dispatch(updateApplicantKey(applicantId, 'dates', res.dates, sessionId)); // TODO: Remove code on next major version
			res.events && dispatch(updateApplicantKey(applicantId, 'events', res.events, sessionId));
			dispatch(sendSocket({ type: 'applicant/update', data: { applicant: applicantId, session: sessionId, updates: [{ key: 'dates', value: res.dates }, { key: 'events', value: res.events }], sendToApplicant: true } }));
		}
		return res.ok;
	}).catch(error => {
		return null;
	});
}

export function setApplicantOptionRequest(sessionId, applicantId, key, value) {
	return dispatch => callApi('applicant/edit', 'post', { applicant: { _id: applicantId, options: { [key]: value } } }).then(res => {
		if(res.applicant) {
			dispatch(updateApplicantKey(applicantId, 'options', res.applicant.options, sessionId));
			dispatch(sendSocket({ type: 'applicant/update', data: { applicant: applicantId, session: sessionId, updates: [{ key: 'options', value: res.applicant.options }], sendToApplicant: true } }));
		}
		return !!res.applicant;
	}).catch(error => {
		return null;
	});
}

export function removeApplicantRequest(applicant, requestAll = true) {
	return dispatch => {
		return callApi('applicant/remove', 'delete', { applicant: { _id: applicant._id } }).then(res => {
			res.ok && requestAll && dispatch(getSessionApplicantsRequest(getApplicantSessionId(applicant), null, true));
			return res.ok;
		}).catch(err => {
			return null;
		});
	};
}

export function resetApplicantsProcessRequest() {
	return dispatch => {
		return callApi('applicants/process/reset').then(res => {
			return res;
		}).catch(err => {
			return null;
		});
	};
}

export function addExtraFileRequest(applicantId, path, isCorrection = false) {
	return dispatch => {
		return callApi('applicant/extrafile/add', 'post', { applicant: { _id: applicantId }, path, isCorrection }).then(res => {
			res.applicant && dispatch(updateApplicantKey(applicantId, 'extraFiles', res.applicant.extraFiles, res.applicant.session));
			return res.applicant;
		}).catch(err => {
			return null;
		});
	};
}

export function generateCopyRequest(applicantId, options = { skipSave: false && process.env.NODE_ENV === 'development' }) {
	return callApi(`applicant/${applicantId}/copy`, 'post', options).then(res => {
		return res && res.content && toArrayBuffer(res.content.data);
	});
}

export function callStopApplicantProctoring(applicant) {
	return dispatch => {
		dispatch(sendSocket({ type: 'applicant/proctor/stop', data: { applicant: applicant._id } }));
	};
}

export function stopApplicantProctoring() {
	return dispatch => {
		console.log('Stop proctoring');
		dispatch(setRedirect('/'));
	};
}

export function activeProctorAudio(applicant, proctor, isActive) {
	return dispatch => {
		dispatch(sendSocket({ type: 'applicant/proctor/audio/toggle', data: { session: getApplicantSessionId(applicant), applicant: applicant._id, proctor: proctor._id, isActive } }));
	};
}

export function sendApplicantNeedAttention(sessionId, applicantId, need = true, type = 'general', extra = {}) {
	return dispatch => {
		dispatch(sendSocket({ type: 'applicant/live/needattention', data: { session: sessionId, applicant: applicantId, need, type, extra } }));
		dispatch(setApplicantNeedAttention(sessionId, applicantId, need, type));
	};
}

// Handle socket for multiple applicants
export function sendApplicantProctoringHandle(sessionId, handles = [], proctor = null) {
	return dispatch => {
		dispatch(sendSocket({ type: 'applicant/live/proctored', data: { session: sessionId, proctor, handles } }));
		dispatch(setApplicantProctoringHandles(sessionId, handles, proctor));
	};
}

// Getters
export function getApplicants(store, sessionId = null) {
	if(sessionId) {
		const session = getSession(store, sessionId);
		return (session && session.applicants) || [];
	}
	return store.applicants.data;
}

export function getActiveApplicants(store) {
	return (store.applicants.data || []).filter(applicant => isApplicantActive(applicant));
}

export function getGroupApplicants(store, sessionId = null) {
	return (store.applicants.groups || []).filter(applicant => !sessionId || sessionId === getApplicantSessionId(applicant));
}

export function getLastProctoringActivity(store) {
	return store.applicants.lastProctoringActivity;
}

export function getApplicantsNeedAttention(store, sessionId = null) {
	return (store.applicants.applicantsNeedAttention || []).filter(attention => !sessionId || attention.session === sessionId);
}

export function getApplicantsProctoringHandler(store) {
	return (store.applicants.applicantsProctoringHandler || []).filter(handler => handler.isHandling);
}

export function getApplicantsGroups(applicants) {
	const groups = [];
	applicants.forEach(applicant => applicant.applicantGroup && groups.push(applicant.applicantGroup.name));

	return unique(groups);
}

export function getApplicantsToProctor(store, sessionId, userId) {
	const session = getSession(store, sessionId);
	const applicants = getApplicants(store, sessionId);
	if(!getSessionOption(session, 'isLiveThesis') && getSessionOption(session, 'maxApplicantsCountByProctor') > 0) {
		return applicants.filter(applicant => getApplicantProctorsIds(applicant).includes(userId));
	}
	return applicants;
}

export function getApplicant(store, id) {
	return store.applicants.data.find(applicant => applicant._id === id);
}

export function getApplicantBySession(store, sessionId) {
	return store.applicants.data.find(applicant => getApplicantSessionId(applicant) === sessionId);
}

export function getApplicantBySessionCode(store, code) {
	return store.applicants.data.find(applicant => applicant.session && applicant.session.code === code);
}

export function getCurrentApplicant(store) {
	return store.applicants.currentApplicant;
}

export function getActiveProctorsAudio(store, applicantId) {
	return (store.applicants.activeProctorsAudio || []).filter(activeProctorAudio => activeProctorAudio.applicant === applicantId);
}

export function getApplicantId(applicant) {
	return (applicant && applicant._id) || applicant;
}

export function getApplicantSessionId(applicant) {
	return applicant && applicant.session && (applicant.session._id || applicant.session);
}

export function getApplicantUserId(applicant) {
	return applicant && applicant.user && (applicant.user._id || applicant.user);
}

export function getApplicantProctorsIds(applicant) {
	return (applicant && applicant.proctors && applicant.proctors.map(proctor => proctor._id || proctor)) || [];
}

export function getApplicantsInGroup(applicants, group) {
	return applicants.filter(applicant => applicant.applicantGroup && applicant.applicantGroup.name === group);
}

export function isApplicantLeader(applicant) {
	return applicant && applicant.applicantGroup && applicant.applicantGroup.leader === applicant._id;
}

export function isApplicantActive(applicant) {
	return applicant.status === APPLICANT_STATUS_ONPROGRESS && isSessionActive(applicant.session, applicant);
}

export function isApplicantUpcoming(applicant) {
	return applicant.status === APPLICANT_STATUS_ONPROGRESS && isSessionUpcoming(applicant.session, applicant);
}

export function canAccessToInstruction(session, applicant) {
	return session
        && applicant
        && session.dates
        && (session.dates.identification || session.dates.startAccess || session.dates.start)
        && moment.utc().isSameOrAfter(moment(session.dates.identification || session.dates.startAccess || session.dates.start));
}

export function canStartInstruction(session, applicant) {
	return canAccessToInstruction(session, applicant) && (!getSessionOption(session, 'isManualStartInstruction') || getApplicantEvent(applicant, 'instructionAllowed', 'last')?.date);
}

export function canAccessToProctor(session, applicant) {
	return session && applicant && (getSessionOption(session, 'isLiveQueue') || (applicant.proctors && applicant.proctors.length > 0));
}

export function canAccessToExam(session, applicant) {
	return session && applicant && applicant.status === APPLICANT_STATUS_ONPROGRESS
        && (!getSessionOption(session, 'isManualStartInstruction') || getApplicantEvent(applicant, 'instructionAllowed', 'last')?.date)
        && (!getSessionOption(session, 'isManualStartExamAccess') || getApplicantEvent(applicant, 'accessAllowed', 'last')?.date)
        && isApplicantActive({ ...applicant, session })
        && moment.utc().isSameOrAfter(moment(session.dates.startAccess || session.dates.start));
}

export function canCorrectApplicant(session, applicant, user) {
	// Once the session correction is validated, the applicant mark is frozen: corrections can no longer be edited
	if([SESSION_STATUS_CORRECTED, SESSION_STATUS_ARCHIVED].includes(session?.status)) {
		return false;
	}
	return (
		['root'].includes(user?.role)
        || (
        	[APPLICANT_STATUS_DONE, APPLICANT_STATUS_ONCORRECTION, APPLICANT_STATUS_CORRECTED].includes(applicant.status)
            && (
            	['root', 'admin', 'manager'].includes(user?.role)
                || (
                	getSessionOption(session, 'isDoubleCorrection') || getSessionOption(session, 'useCorrectorsDistribution')
                		? (applicant.correctorsAssignation || []).find(assignation => assignation.corrector === user?._id && assignation.status === 'pending')
                		: canCorrectSession(session, user, true)
                )
            )
        )
	);
}

export function getApplicantExternal(applicant, external) {
	if(applicant && applicant.external) {
		return applicant.external[external];
	}
	return '';
}

export function getApplicantOption(applicant, option) {
	if(applicant && applicant.options) {
		return applicant.options[option];
	}
	return '';
}

export function getApplicantEvents(applicant) {
	return getModelEvents(applicant);
}

export function getApplicantEvent(applicant, eventName, mode = 'last') {
	return getModelEvent(applicant, eventName, mode);
}

export function getApplicantSelectedQuestions(subject, applicant) {
	return ((applicant.selectedQuestions || {}).questions || [])
		.map(questionOrQuestionId => ((subject || {}).questions || []).find(question => question._id.toString() === (questionOrQuestionId._id || questionOrQuestionId).toString()))
		.filter(question => question);
}

export function getApplicantTimePassed(session, applicant) {
	if(getApplicantEvent(applicant, 'access') || getApplicantEvent(applicant, 'liveStarted')) {
		// const isExamSession = session.subject && session.subjectData;
		const isLiveSession = getSessionOption(session, 'isLiveProctoring');

		let applicantStart = getApplicantEvent(applicant, 'access', 'first')?.date;
		let applicantEnd = getApplicantEvent(applicant, 'finish', 'last')?.date || getSessionEnd(session, applicant);
		if(isLiveSession /* && !isExamSession */) {
			applicantStart = getApplicantEvent(applicant, 'liveStarted', 'first')?.date || applicantStart;
			applicantEnd = getApplicantEvent(applicant, 'finish', 'last')?.date || getApplicantEvent(applicant, 'liveStopped', 'last')?.date || applicantEnd;
		}
		console.log(applicantStart.toString(), '-->', applicantEnd.toString());
		const applicantSessionDuration = moment.duration(moment(applicantEnd).diff(moment(applicantStart)));
		const hoursCount = applicantSessionDuration.as('hours');
		console.log('Applicant time count:', `${Math.round(hoursCount)} hours ${(hoursCount - Math.round(hoursCount)) * 60} minutes`);
		console.log('rounded hours:', Math.round(hoursCount * 100, 2) / 100);
		return hoursCount;
	}
	return 0;
}

export function getApplicantPageAccessDate(applicant, pageId, mode = 'all') {
	let method = '';
	switch(mode) {
	case 'first':
		method = 'find';
		break;

	case 'last':
		method = 'findLast';
		break;

	default:
		method = 'filter';
	}

	if(applicant.events?.length) {
		const pageAccessEvents = getApplicantEvent(applicant, 'pagesAccess', 'all');
		if(pageAccessEvents) {
			if(mode === 'all') {
				return pageAccessEvents.filter(event => event.page === pageId).map(event => event.date);
			}
			return (pageAccessEvents[method](event => event.page === pageId) || {}).date;
		}
	}
	const pageAccess = (applicant.dates?.pagesAccess || {})[pageId] || [];
	return mode === 'all' ? pageAccess : pageAccess[mode === 'last' ? pageAccess.length - 1 : 0];
}

export function getApplicantTimeElapsedByPage(applicant, targetPageId, timeUnit = 'minutes') {
	let timeline = [];
	applicant.selectedQuestions.pages.forEach(pageId => {
		const pageAccesses = getApplicantPageAccessDate(applicant, pageId, 'all');
		if(pageAccesses?.length) {
			timeline.push(
				...pageAccesses.map(date => ({
					page: pageId,
					date,
				})),
			);
		}
	});
	const applicantFinishDate = getApplicantEvent(applicant, 'finish');
	if(applicantFinishDate) {
		timeline.push({
			page: '',
			date: applicantFinishDate.date,
		});
	}
	timeline = timeline.sort((tA, tB) => new Date(tA.date) - new Date(tB.date));
	const timeElapsed = {};
	let prevPageId = null;
	timeline.forEach((timePoint, index) => {
		if(prevPageId) {
			if(!timeElapsed[prevPageId]) {
				timeElapsed[prevPageId] = [];
			}
			timeElapsed[prevPageId].push(moment.duration(moment(timePoint.date).diff(moment.utc(timeline[index - 1].date))).as(timeUnit));
		}
		prevPageId = timePoint.page;
	});
	return timeElapsed[targetPageId];
}

export function getApplicantSelectedVariables(applicant) {
	const vars = applicant.selectedVariables || {};
	Object.keys(applicant.external || {}).forEach(key => {
		vars[`applicantExternal${capitalizeFirstLetter(key)}`] = applicant.external[key];
	});
	if(applicant.anonymousIdentifier) {
		vars.applicantAnonymousIdentifier = applicant.anonymousIdentifier;
	}
	return vars;
}

export function getApplicantProgressValue(applicant) {
	let value = 0;
	const { dateStatus } = applicant;
	if(getApplicantEvent(applicant, 'convocation', 'first')) {
		value += 1;
	}
	if(getApplicantEvent(applicant, 'liveStarted', 'first')) {
		value += 1;
	}
	if(getApplicantEvent(applicant, 'finish', 'last') || getApplicantEvent(applicant, 'liveStopped', 'last')) {
		value += 1;
	}
	if(dateStatus && dateStatus.corrected) {
		value = 4; // Not incremental => can be corrected without be started
	}
	return value;
}

export function getApplicantStatusColor(applicant) {
	switch(applicant.status) {
	case APPLICANT_STATUS_PENDING:
		return 'primary';

	case APPLICANT_STATUS_ONPROGRESS:
		return 'success';

	case APPLICANT_STATUS_ONPROCESS:
	case APPLICANT_STATUS_ONCORRECTION:
		return 'warning';

	case APPLICANT_STATUS_DONE:
	default:
		return 'info';
	}
}

export function getApplicantMarks(session, applicant, corrections = []) {
	// console.log(session.subjectData, applicant.selectedQuestions, corrections);
	let realMarkEdited = applicant.selectedQuestions
		? (applicant.selectedQuestions.questions || [])
			.filter(questionOrQuestionId => !session.subjectData || session.subjectData.questions.find(question => question._id.toString() === (questionOrQuestionId?._id || questionOrQuestionId).toString()))
			.reduce((total, questionOrQuestionId) => {
				const questionId = (questionOrQuestionId?._id || questionOrQuestionId).toString();
				const correctionOrAnswer = (corrections || []).find(correction => correction.question?.toString() === questionId) || getApplicantQuestionAnswer(applicant, questionId?._id || questionId) || {};
				// !correctionOrAnswer?.mark && console.log('no correction or answer', questionId, corrections.map(correction => correction.question?.toString()));
				return total + parseFloat(correctionOrAnswer?.mark || 0);
			}, 0)
		: (applicant.marks?.real || 0);

	realMarkEdited = Math.round(realMarkEdited * 100) / 100;

	return {
		...(applicant.marks || {}),
		real: realMarkEdited,
		final: getFinalMark(session, applicant, realMarkEdited),
	};
}

/*
 * Compare the mark saved on the applicant with the one recalculated from the current corrections.
 * A gap means a correction has been edited after the copy validation: the saved mark (used by exports,
 * statistics and webservices) is outdated until the correction is validated again.
 */
export function getApplicantMarksGap(session, applicant, corrections = []) {
	if(!applicant?.marks || applicant.status !== APPLICANT_STATUS_CORRECTED) {
		return null;
	}

	const savedMarks = applicant.marks;
	const computedMarks = getApplicantMarks(session, applicant, corrections);

	if(parseFloat(savedMarks.real || 0) === parseFloat(computedMarks.real || 0) && parseFloat(savedMarks.final || 0) === parseFloat(computedMarks.final || 0)) {
		return null;
	}

	return {
		saved: savedMarks,
		computed: computedMarks,
	};
}

// Export Actions
export function setApplicants(applicants, isSet = true) {
	return {
		type: SET_APPLICANTS,
		applicants,
		isSet,
	};
}

export function setSessionApplicants(sessionId, applicants) {
	return {
		type: SET_SESSION_APPLICANTS,
		sessionId,
		applicants,
	};
}

export function setGroupApplicants(applicants) {
	return {
		type: SET_GROUP_APPLICANTS,
		applicants,
	};
}

export function updateApplicantKey(applicantId, key, value, sessionId = null) {
	return {
		type: UPDATE_APPLICANT_KEY,
		applicantId,
		sessionId,
		key,
		value,
	};
}

export function updateGroupApplicantAnswer(applicantId, answers) {
	return {
		type: UPDATE_GROUP_APPLICANT_ANSWER,
		applicantId,
		answers,
	};
}

export function setCurrentApplicant(applicant) {
	return {
		type: SET_CURRENT_APPLICANT,
		applicant,
	};
}

export function setApplicantNeedAttention(sessionId, applicantId, need = true, attentionType = 'general', data = {}) {
	return {
		type: SET_APPLICANT_ATTENTION,
		session: sessionId,
		applicant: applicantId,
		need,
		attentionType,
		data,
	};
}

export function setLastProctoringActivity(sessionId, applicantId, timestamp = undefined) {
	return {
		type: SET_LAST_PROCTORING_ACTIVITY,
		sessionId,
		applicantId,
		timestamp: timestamp !== undefined ? timestamp : moment.utc().unix(),
	};
}

export function setApplicantProctoringHandles(sessionId, handles = [], proctorId = null) {
	return {
		type: SET_APPLICANT_PROCTORING_HANDLES,
		sessionId,
		handles,
		proctorId,
	};
}

export function setProctorAudioActive(sessionId, applicantId, proctorId, isActive = true) {
	return {
		type: SET_APPLICANT_PROCTOR_AUDIO_ACTIVE,
		sessionId,
		applicantId,
		proctorId,
		isActive,
	};
}
